var KBSummaryCategories = React.createClass({
  propTypes: {
    browsePaths: React.PropTypes.array,
    onCategoryClicked: React.PropTypes.func.isRequired
  },
  getDefaultProps() {
    return {
      browsePaths: []
    }
  },
  categoryClicked(path) {
    this.props.onCategoryClicked(path);
  },
  renderItem(path) {
    let pathArray = path.value.split("//");
    let displayName = pathArray[pathArray.length - 1];

    return (
        <li className="" key={path.value}>
          <a href="#" onClick={this.categoryClicked.bind(this, path.value)}>{displayName}</a> <span className="text-muted">({path.hits})</span>
        </li>
      )
  },

  render() {
    if (this.props.browsePaths.length == 0) {
      return <div></div>;
    }

    let items = this.props.browsePaths.map(this.renderItem);

    return (
      <div className="cat-matches">
        <h3 className="cat-matches__title">{Labels.getLabel("Show results in these categories")}:</h3>
        <ul className="cat-matches__list bullet-list">
          {items}
        </ul>
      </div>
    )
  }
});